import { throttle } from "lodash";

declare const jQuery: any;
const $ = jQuery;

export function initLargeContentRowSlider(): void
{
    const $wraps = $(".gcf-large-square-content-row-slider");
    if ($wraps.length === 0)
    {
        return;
    }
    $wraps.each(function () {
        const $wrap = $(this);
        const $textItems = $wrap.find(".text-item");
        const numItems: number = $textItems.length;
        if (numItems < 2)
        {
            return;
        }
        let index: number = 0;
        const finalIndex: number = numItems - 1;
        const incrementIndex = () => {
            ++index;
            if (index > finalIndex)
            {
                index = 0;
            }
        };
        const decrementIndex = () => {
            --index;
            if (index < 0)
            {
                index = finalIndex;
            }
        };
        const $imagesWrap = $wrap.find(".image-items-inner");
        const $textsWrap = $wrap.find(".text-items-inner");
        const updateView = () => {
            const itemWidth: number = $textItems.outerWidth();
            const xPercent: number = -index * itemWidth;
            const transform: string = `translateX(${xPercent}px)`;
            $imagesWrap.css({ transform });
            $textsWrap.css({ transform });
        };
        $wrap.find(".nav-btn-prev").on("click", function (e) {
            decrementIndex();
            updateView();
        });
        $wrap.find(".nav-btn-next").on("click", function (e) {
            incrementIndex();
            updateView();
        });
        $(window).on("resize", throttle(updateView, 90, { trailing: true }));
    });
}

